import {createSlice, type PayloadAction} from '@reduxjs/toolkit';
import type {AddTeamMembersDialogData, AddTeamMembersPanelState} from '@Panels/add-team-members-panel/add-team-members-panel.types';
import {getAddTeamMembersDialogData} from '@Panels/add-team-members-panel/add-team-members-panel-thunk';
import type {SubscriptionCheckoutRequest} from '@Components/checkout-flow/checkout-flow.types';

const initialState: AddTeamMembersPanelState = {
  isWaitingForAJAXResponse: false,
  data: null,
  checkoutRequest: null,
};

export const addTeamMembersPanelSlice = createSlice({
  name: 'addTeamMembersPanel',
  initialState,
  reducers: {
    resetAddTeamMembersPanel: () => {
      return initialState;
    },
    startAddTeamMembersCheckout: (state, {payload}: PayloadAction<SubscriptionCheckoutRequest>) => {
      state.checkoutRequest = payload;
    },
    clearAddTeamMembersCheckout: (state) => {
      state.checkoutRequest = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAddTeamMembersDialogData.pending, (state) => {
      state.isWaitingForAJAXResponse = true;
    });
    builder.addCase(getAddTeamMembersDialogData.fulfilled, (state, {payload}: PayloadAction<AddTeamMembersDialogData>) => {
      state.data = payload;
      state.isWaitingForAJAXResponse = false;
    });
    builder.addCase(getAddTeamMembersDialogData.rejected, (state) => {
      state.isWaitingForAJAXResponse = false;
    });
  },
});

export const {resetAddTeamMembersPanel, startAddTeamMembersCheckout, clearAddTeamMembersCheckout} = addTeamMembersPanelSlice.actions;
export const addTeamMembersPanelReducer = addTeamMembersPanelSlice.reducer;
